import { ceil, floor } from 'lodash-es';
import { bignumberDivide } from './index';

// 乘法，最大保留几位小数默认为8
export const accMul = (arg1: number, arg2: number, len: number = 8) => {
  let m = 0;
  let s1 = arg1 ? arg1.toString() : '';
  let s2 = arg2 ? arg2.toString() : '';
  let m1 = s1.split('.')[1]?.length ?? 0;
  let m2 = s2.split('.')[1]?.length ?? 0;
  m += m1 + m2;
  let result = (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
  if (len === 0) {
    return result;
  }
  return result.toFixed(len);
};

export const padLeadingZero = value => {
  return value > 9 ? value : `0${value}`;
};

export const utilsTotal = {
  moneyToFloat: (num, d = 0) => {
    return accMul(num, 0.001, d);
  },
  dateFormat: (t, style = 1) => {
    if (!/^\d+$/.test(t)) return t; // 如果是时间字符串则直接返回
    let d = new Date();
    d.setTime(t);
    if (style === 2) {
      return `${d.getFullYear()}/${padLeadingZero(d.getMonth() + 1)}/${padLeadingZero(d.getDate())}`;
    } else if (style === 21) {
      // style === 2 的变种，只是改 / 为 -
      return `${d.getFullYear()}-${padLeadingZero(d.getMonth() + 1)}-${padLeadingZero(d.getDate())}`;
    } else if (style === 3) {
      return `${d.getFullYear()}-${padLeadingZero(d.getMonth() + 1)}`;
    } else if (style === 4) {
      return `${d.getFullYear()}-${padLeadingZero(d.getMonth() + 1)}-${padLeadingZero(d.getDate())} ${padLeadingZero(d.getHours())}:${padLeadingZero(d.getMinutes())}`;
    } else if (style === 5) {
      return `${d.getFullYear()}/${padLeadingZero(d.getMonth() + 1)}/${padLeadingZero(d.getDate())} ${padLeadingZero(d.getHours())}:${padLeadingZero(d.getMinutes())}:${padLeadingZero(
        d.getSeconds()
      )}`;
    }
    return `${d.getFullYear()}-${padLeadingZero(d.getMonth() + 1)}-${padLeadingZero(d.getDate())} ${padLeadingZero(d.getHours())}:${padLeadingZero(d.getMinutes())}:${padLeadingZero(d.getSeconds())}`;
  },
  formatString: (str: string, startLength: number = 6, endLength: number = 4) => {
    if (str.length <= startLength + endLength) {
      return str;
    } else {
      return str.substring(0, startLength) + '...' + str.substring(str.length - endLength, str.length);
    }
  },
};

export const moneyString = num => {
  return Number(num).toFixed(3);
};

/**
 * @param num 金额
 * @param precision 小数精度
 * @param mode floor向下保留小数，ceil向上保留小数
 */
export const moneyHandle = (num: number, precision: number = 2, mode: 'floor' | 'ceil' = 'floor') => {
  const value = num || 0;
  const result =
    mode === 'floor' ? floor(bignumberDivide(value, 1000), precision) : ceil(bignumberDivide(value, 1000), precision);
  // return bignumberToFormat(result, precision);
  return result.toFixed(precision);
};

// 数字左边补0
export const strPadLeft = (str, length) => {
  if (str.toString().length >= length) {
    return str;
  } else {
    return strPadLeft('0' + str, length);
  }
};

export const randomInteger = (low, high) => {
  return low + Math.floor(Math.random() * (high - low));
};

// 科学计数数字转字符串
export const transToNumber = num => {
  if (isNaN(num)) return num;
  num = '' + num;
  num = parseFloat(num);
  let eformat = num.toExponential(); // 转换为标准的科学计数法形式（字符串）
  let tmpArray = eformat.match(/\d(?:\.(\d*))?e([+-]\d+)/); // 分离出小数值和指数值
  let number = num.toFixed(Math.max(0, (tmpArray[1] || '').length - tmpArray[2]));
  return number;
};

// 少十补零
export const addZero = (num: number | string): string => (parseInt(num + '') < 10 ? '0' + num : num + '');

// 浮点数相加
export const accAdd = (arg1: any, arg2: any) => {
  let r1: number, r2: number, m: number, c: number;
  r1 = arg1.toString().split('.')[1]?.length ?? 0;
  r2 = arg2.toString().split('.')[1]?.length ?? 0;
  c = Math.abs(r1 - r2);
  m = Math.pow(10, Math.max(r1, r2));
  if (c > 0) {
    var cm = Math.pow(10, c);
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace('.', ''));
      arg2 = Number(arg2.toString().replace('.', '')) * cm;
    } else {
      arg1 = Number(arg1.toString().replace('.', '')) * cm;
      arg2 = Number(arg2.toString().replace('.', ''));
    }
  } else {
    arg1 = Number(arg1.toString().replace('.', ''));
    arg2 = Number(arg2.toString().replace('.', ''));
  }
  return (arg1 + arg2) / m;
};

// 输入时间对象 返回 年/月/日 时:分:秒 perxp 为分隔符 默认 '/', ':' type = 'YMDhms'
export const getYMDHMS = (date: Date | number | string, perxp: string = '/', hxp: string = ':', type = '') => {
  // string = '2020/07/10 15:54:23' 时间字符串
  if ((typeof date).toLowerCase() === 'number' || (typeof date).toLowerCase() === 'string') {
    date = new Date(date);
  }
  date = date as Date;
  const year = date.getFullYear();
  let _month = addZero(date.getMonth() + 1);
  let _day = addZero(date.getDate());
  let h = addZero(date.getHours());
  let m = addZero(date.getMinutes());
  let s = addZero(date.getSeconds());
  if (type) {
    if (type === 'YMD') return `${year + perxp + _month + perxp + _day}`;
    if (type === 'MD') return `${_month + perxp + _day}`;
    if (type === 'MDhms') return `${_month + perxp + _day} ${h + hxp + m + hxp + s}`;
    if (type === 'MDhm') return `${_month + perxp + _day} ${h + hxp + m}`;
    else if (type === 'Dhms') return `${_day} ${h + hxp + m + hxp + s}`;
    else if (type === 'Dhm') return `${_day} ${h + hxp + m}`;
    else if (type === 'hms') return `${h + hxp + m + hxp + s}`;
    else if (type === 'hm') return `${h + hxp + m}`;
    else if (type === 'ms') return `${m + hxp + s}`;
  }
  return `${year + perxp + _month + perxp + _day} ${h + hxp + m + hxp + s}`;
};

// 浮点数相减
export const accSub = (arg1: any, arg2: any) => {
  let r1: number, r2: number, m: number, c: number;
  r1 = arg1.toString().split('.')[1]?.length ?? 0;
  r2 = arg2.toString().split('.')[1]?.length ?? 0;
  c = Math.abs(r1 - r2);
  m = Math.pow(10, Math.max(r1, r2));
  if (c > 0) {
    var cm = Math.pow(10, c);
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace('.', ''));
      arg2 = Number(arg2.toString().replace('.', '')) * cm;
    } else {
      arg1 = Number(arg1.toString().replace('.', '')) * cm;
      arg2 = Number(arg2.toString().replace('.', ''));
    }
  } else {
    arg1 = Number(arg1.toString().replace('.', ''));
    arg2 = Number(arg2.toString().replace('.', ''));
  }
  return (arg1 - arg2) / m;
};

// 金额乘1000
export const num2Li = (num: number, px = 1000) => num * px;

// 判断是否为纯整数
export const checkInteger = value => {
  let reg = /^[1-9]\d*$|^0$/; // 注意：故意限制了 0321 这种格式，如不需要，直接reg=/^\d+$/
  return reg.test(value);
};
